/**
 * @author WYX
 * @date 2019/12/26
 * @Description: 稿件标签指令模块
 */
angular.module('messageChangeModule', []).directive('messageChange', [
    '$timeout',
    '$modal',
    'mrApiService',
    '$stateParams',
    'modalDialog',
    'trsspliceString',
    'messagePublishService',
    'trsHttpService',
    'mrService',
    '$validation',
    function ($timeout, $modal, mrApiService, $stateParams, modalDialog, trsspliceString, messagePublishService, trsHttpService, mrService, $validation) {
        return {
            scope: true, // 继承作用域
            restrict: 'EA',
            templateUrl: './resourceCenter/directive/resourceList/messageChange/messageChange.html',
            replace: true,
            transclude: true,
            link: function($scope, $elem, $attrs) {
                initStatus();

                // 监听是否有修改窗口打开请求基础数据
                messagePublishService.subscribe(
                    'changeMessageItem',
                    function (event, data) {
                        $scope.data.currentItem = data;
                        initData();
                    },
                    $scope
                );

                /**
                 * [initStatus description]初始化状态
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    $scope.data = {
                        // 人物标签
                        personMark: [],
                        // 地点标签
                        placeMark: [],
                        // 事物标签
                        eventMark: [],
                        // 版权信息
                        checkOrigin: null,
                        // 类型数组
                        // articleClassArr: [],
                        // 选择类型
                        selectClass: '',
                        // 获取打开对象
                        currentItem: null,
                        // 存储上传的封面图
                        thumbimg: null,
                        currentMarkType: '',
                    };
                    $scope.status = {
                        allType: [{
                            name: '导演',
                            type: 'director',
                        }, {
                            name: '策划',
                            type: 'planner',
                        }, {
                            name: '编导',
                            type: 'editdirector',
                        }, {
                            name: '后期制作',
                            type: 'postproducer',
                        }, {
                            name: '主持人',
                            type: 'hostess',
                        }, {
                            name: '导播',
                            type: 'transitiondirector',
                        }, {
                            name: '设计',
                            type: 'designer',
                        }, {
                            name: '记者',
                            type: 'reporter',
                        }, {
                            name: '编辑',
                            type: 'editor',
                        }, {
                            name: '监制',
                            type: 'producer',
                        }, {
                            name: '摄影',
                            type: 'cameraman',
                        }, {
                            name: '摄像',
                            type: 'photographer',
                        }, {
                            name: '运营',
                            type: 'operator',
                        }, {
                            name: '特效',
                            type: 'specialeffectartist',
                        }],
                        originTyps: [{
                            name: '原创',
                            value: 1,
                        }, {
                            name: '转载',
                            value: 0,
                        }],
                        videoMsg: {},
                        imageUploadUrl: trsHttpService.getMRURL() + '/thumb/upload',
                        isShowPlaceMarkTip: false,
                    };
                    $scope.editorJson = [];
                    $scope.resourceTypeName = getResourceTypeName();
                    $scope.itemDetail = null;
                    $scope.uploadThumb = {
                        success: function(file, src) {
                            // 成功回调
                            $scope.itemDetail.thumbimg = src.datas.previewurl;
                            $scope.data.thumbimg = src.datas.relativeresourceurl;
                            $scope.$apply();
                        },
                        error: function(file) {
                            // 失败回调
                        },
                        file: function(file, uploader) {
                            // 添加文件回调
                        },
                        tar: function(file, percentage) {
                            // 进度回调
                        },
                        start: function(file) {
                            // 开始回调
                        },
                        comp: function(file) {
                            // 上传完成回调
                        },
                        finish: function(file) {
                            // 结束回调
                        },
                    };
                }

                /**
                 * 获取类型
                 * @returns {*}
                 */
                function getResourceTypeName() {
                    let resourcetype = $stateParams.resourcetype;
                    let resourcetypeNameMap = {
                        '0': '图片',
                        '1': '音频',
                        '2': '视频',
                    };
                    return resourcetypeNameMap[resourcetype];
                }

                /**
                 * [initData description]初始化数据
                 *
                 * @return  {[type]}  [return description]
                 */
                function initData() {
                    mrApiService.getMaterialDetail(angular.extend({}, $scope.basicalStatus.commonParams, { relationId: $scope.data.currentItem.relationid, })).then(function (data) {
                        if (data.code === '200') {
                            $scope.itemDetail = data.datas[0];
                            initInfo();
                        } else {
                            modalDialog.alertType('错误', '获取数据失败', 'warning', false);
                            initInfo();
                        }
                    }, function (data) {
                        modalDialog.alertType('错误', '获取数据失败', 'warning', false);
                        initInfo();
                    });
                }

                /**
                 * 回显信息初始化
                 */
                function initInfo() {
                    // 初始化人物
                    initPerson();
                    // 初始化标签
                    initMark();
                    // 初始化分类
                    // initCategory();
                    // 初始化版权
                    initOrigin();
                }


                /**
                 * [initPerson description]初始化人物选择参数
                 * 人物添加数据
                 * @return  {[type]}  [return description]
                 */
                function initPerson() {
                    $scope.status.allType.forEach((item) => {
                        $scope.data[item.type] = getPersons(item.type);
                    });
                }

                /**
                 * 处理人物数组
                 * @param type
                 * @returns {Array|*}
                 */
                function getPersons(type) {
                    if ($scope.itemDetail[type]) {
                        return $scope.itemDetail[type].split(',');
                    } else {
                        return [];
                    }
                }

                /**
                 * [closeDia description]关闭弹窗
                 *
                 * @return  {[type]}  [return description]
                 */
                $scope.closeDia = function (check) {
                    if (check){
                        modalDialog.confirmModal('提示信息', '现在退出将不对素材进行保存，是否确认退出', function() {
                            $scope.basicalStatus.showMessage = false;
                            $scope.data.searchEventWord = '';
                            $scope.data.searchPlaceWord = '';
                            $timeout(() => {
                                $scope.basicalStatus.showMessage = null;
                            }, 500);
                        }, () => {
                            return;
                        });
                    } else {
                        $scope.basicalStatus.showMessage = false;
                        $scope.data.searchEventWord = '';
                        $scope.data.searchPlaceWord = '';
                        $timeout(() => {
                            $scope.basicalStatus.showMessage = null;
                        }, 500);
                    }
                };

                /*
                 * [selectOriginChange description]改变单选版权信息
                 * @return  {[type]}  [return description]
                 */
                $scope.setSelect = function(type) {
                    $scope.data.checkOrigin = type.value;
                };

                /*
                 * [authDelete description]删除人物
                 * @return  {[type]}  [return description]
                 */
                $scope.authDelete = function(name, index) {
                    $scope.data[name].splice(index, 1);
                };

                /*
                 * [authAdd description]添加人物
                 * @return  {[type]}  [return description]
                 */
                $scope.authAdd = function(name) {
                    var modalInstance = $modal.open({
                        templateUrl: './editingCenter/directive/app/views/editor_window_other_tpl.html',
                        scope: $scope,
                        windowClass: 'editor_window_class',
                        backdrop: false,
                        controller: 'editorOtherCtrl',
                    });
                    modalInstance.result.then(function(result) {
                        if (result.length) {
                            result.forEach((item) => {
                                $scope.data[name].push(item.USERNAME);
                            });
                        }
                        
                    });
                };

                /*
               * [saveMessage description]保存方法
               * @return  {[type]}  [return description]
               */
                $scope.saveMessage = function () {
                    var eventmark = '';
                    var personmark = '';
                    var placemark = '';
                    if ($scope.basicalStatus.commonParams.mainResourceType !== '0') {
                        eventmark = trsspliceString.spliceString(angular.copy($scope.data.eventMark), 'name', ';');
                        personmark = trsspliceString.spliceString(angular.copy($scope.data.personMark), 'name', ';');
                        placemark = trsspliceString.spliceString(angular.copy($scope.data.placeMark), 'name', ';');
                    } else {
                        if ($scope.data.selectedEventTips && $scope.data.selectedEventTips.length) {
                            for (var j = 0; j < $scope.data.selectedEventTips.length; j++) {
                                if ($scope.data.selectedEventTips[j].id === '0' && !$scope.data.selectedEventTips[j].imageurl) {
                                    $scope.data.selectedEventTips[j].imageurl = $scope.itemDetail.previewurl;
                                }
                            }
                            eventmark = JSON.stringify($scope.data.selectedEventTips);
                        }
                        if ($scope.data.selectedPlaceTips && $scope.data.selectedPlaceTips.length) {
                            placemark = JSON.stringify($scope.data.selectedPlaceTips);
                        }
                        if ($scope.data.personTips && $scope.data.personTips.length) {
                            personmark = JSON.stringify($scope.data.personTips);
                        }
                    }
                    let params = {
                        relationId: $scope.itemDetail.relationid,
                        resourceTitle: $scope.itemDetail.resourcetitle,
                        eventmark: eventmark,
                        personmark: personmark,
                        placemark: placemark,
                        // zyzxfield: $scope.itemDetail.zyzxfield,
                        content: $scope.itemDetail.content,
                        thumbimg: $scope.data.thumbimg,
                        original: $scope.data.checkOrigin,
                        isUpload: 0, // 更新时必须穿，后台判断用
                        fileId: $scope.basicalStatus.currentFolderId || 0,
                        price: $scope.itemDetail.price,
                        author: $scope.itemDetail.author,
                        filmingEvent: $scope.itemDetail.filmingevent,
                        filmingLocation: $scope.itemDetail.filminglocation,
                        filmingTime: $scope.itemDetail.filmingtime
                    };
                    // 如果是视频需要添加额外参数
                    if ($scope.resourceTypeName === '视频'){
                        $scope.status.allType.forEach((item) => {
                            params[item.type] = angular.copy($scope.data[item.type]).join(',');
                        });
                    }

                    $scope.messageChange.$pending = {};
                    $validation.validate($scope.messageChange).success(function() {
                        updateMaterial(params);
                    });
                    
                };

                /**
                 * [updateMaterial 更新媒资信息]
                 *
                 * @param   {[type]}  params  [params description]
                 *
                 * @return  {[type]}          [return description]
                 */
                function updateMaterial(params){
                    mrApiService.updateMaterial(angular.extend(params, $scope.basicalStatus.commonParams)).then((response) => {
                        if (response.code === '200') {
                            modalDialog.alertType('保存成功', '', 'success', false);
                            $scope.data.thumbimg = null;
                            $scope.requestData();
                            $scope.closeDia();
                        } else {
                            modalDialog.alertType('保存失败', '请重试', 'warning', false);
                        }
                    }, () => {
                        modalDialog.alertType('保存失败', '请重试', 'warning', false);
                    });
                }

                // 标签方法
                /**
                 * [initKeyWords description]初始化关键词
                 * @return {[type]} [description]
                 */
                $scope.checkTag = function (tag) {
                    $scope.keywordsTips = '';
                    $scope.isShowKeywordTips = false;
                    if (tag.name.indexOf(' ') > -1) {
                        var spaceArr = tag.name.split(' ');
                        $timeout(function () {
                            $scope.data.label.pop();
                            var containArr = [];
                            for (var j = 0; j < $scope.data.label.length; j++) {
                                containArr.push($scope.data.KEYWORDS[j].name);
                            }
                            for (var i = 0; i < spaceArr.length; i++) {
                                if (containArr.indexOf(spaceArr[i]) < 0 && spaceArr[i] != '') {
                                    $scope.data.label.push({ name: spaceArr[i], });
                                    containArr.push(spaceArr[i]);
                                }
                            }
                        });
                    }
                };

                $scope.invalidTag = function(tag) {
                    var reg = /^[^<>\/;]*$/;
                    if (tag.name.length > 8) {
                        $scope.isShowKeywordTips = true;
                        $scope.keywordsTips = '单个标签长度不能超过8！';
                    }
                    if (!reg.test(tag.name)) {
                        $scope.isShowKeywordTips = true;
                        $scope.keywordsTips = '不能包含特殊字符！';
                    }
                };

                /**
                 * [isShowPrice 是否显示售价]
                 *
                 * @return  {[type]}  [return description]
                 */
                $scope.isShowPrice = function() {
                    return $scope.basicalStatus.commonParams.mainResourceType === '0' && $scope.basicalStatus.commonParams.mrType === 'meizi';
                };
                // $scope.setCover = function(item) {};

                /**
                 * [initPersonMark 初始化人物标签]
                 *
                 * @return  {[type]}  [return description]
                 */
                function initMark() {
                    if ($scope.basicalStatus.commonParams.mainResourceType === '0') {
                        $scope.data.personTips = $scope.itemDetail.personlabels;
                        $scope.data.selectedPlaceTips = $scope.itemDetail.placelabels;
                        $scope.data.selectedEventTips = $scope.itemDetail.eventlabels;
                    } else {
                        $scope.data.personMark = $scope.itemDetail.personmark ? $scope.itemDetail.personmark.split(';') : [];
                        $scope.data.placeMark = $scope.itemDetail.placemark ? $scope.itemDetail.placemark.split(';') : [];
                        $scope.data.eventMark = $scope.itemDetail.eventmark ? $scope.itemDetail.eventmark.split(';') : [];
                    }
                }

                /**
                 * [initCategory 初始化分类]
                 *
                 * @return  {[type]}  [return description]
                 */
                function initCategory() {
                    mrApiService.getThemeData().then(function (data) {
                        $scope.data.articleClassArr = data;
                        // $scope.data.selectClass = data[0];
                        getselecedClass();
                    });
                }

                /**
                 * [getselecedClass 获取当前选中分类]
                 *
                 * @return  {[type]}  [return description]
                 */
                function getselecedClass() {
                    $scope.data.articleClassArr.forEach(function (element) {
                        if (element.id === $scope.itemDetail.zyzxfield) {
                            $scope.data.selectClass = element;
                        }
                    });
                }

                /**
                 * [initOrigin 初始化版权类型]
                 *
                 * @return  {[type]}  [return description]
                 */
                function initOrigin() {
                    $scope.data.checkOrigin = $scope.itemDetail.original ? $scope.itemDetail.original : 0;
                }


                /**
                 * [loadTips description] 加载事物标签或者地点标签
                 *
                 * @param   {[type]}  word  [word description]
                 * @param   {[type]}  type  [type description]
                 * @param   {[type]}  item  [item description]
                 *
                 * @return  {[type]}        [return description]
                 */
                $scope.loadTips = function(word, type, item) {
                    $scope.data.currentMarkType = type;
                    $scope.loadingPromise = mrService.loadTips($scope, word, type).then(function(data){
                        if (!data.length && type === 'place' && item.searchPlaceWord !== '') {
                            $scope.status.isShowPlaceMarkTip = true;
                        } else if (type === 'place' && (data.length || item.searchPlaceWord === '')) {
                            $scope.status.isShowPlaceMarkTip = false;
                        }
                        item[type] = data;
                        item = mrService.addTag(item, data, type, word);
                    });
                };

                /**
                 * [setClass 改变类型回调]
                 *
                 * @return  {[type]}  [return description]
                 */
                $scope.setClass = function () {
                    $scope.itemDetail.zyzxfield = $scope.data.selectClass.id;
                };

                /**
                 * [isShowLabelTips 是否显示事物标签错误提示]
                 *
                 * @param   {[type]}  type  [type description]
                 *
                 * @return  {[type]}        [return description]
                 */
                $scope.isShowLabelTips = function(type) {
                    return $scope.basicalStatus.commonParams.mainResourceType === '0' && $scope.data.searchEventWord && $scope.data.searchEventWord !== '' && $scope.messageChange.$error.leftoverText && type === 'event';
                };
            },
        };
    },
]);
